





















import {IFilterItem} from '../../models/filter-item-model';
import ActiveFilter from './ActiveFilter.vue';
import {defineComponent, PropType} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: 'ActiveFilters',
  components: {
    ActiveFilter
  },
  props: {
    items: {type: Array as PropType<IFilterItem[]>}
  },
  setup: () => {
    const {labels} = useGetters(['labels'])

    return {
      labels
    }
  }
})
